export default __webpack_public_path__ + "static/media/doctorLogin.b800efff.jpg";